import { WORDS } from "./words";

/** 目前本機實際可用的詞數（顯示詞數的唯一來源） */
export const CORPUS_SIZE = WORDS.length;

export const corpusLabel = (name: string) =>
  `${name} · ${CORPUS_SIZE.toLocaleString("en-US")} 詞`;